export default "__VITE_ASSET__Bg7W6LJZ__"